// Don't use any of these variables the setupFitment action because that is run both on the client and the server!!
// You will poison the server instance if you do!!
let didNotSave = true
let autoSelectEnabled = true

const showFitmentModal = function ({ commit }, options = {}) {
    const { isFitsMode = false, isSameDayShippingMode = false, isMMYMode = false } = options

    commit('setFitsMode', isFitsMode)
    commit('setIsSameDayShippingMode', isSameDayShippingMode)
    commit('setMMYMode', isMMYMode)

    didNotSave = true

    this.$overlay.show('fitment')
}

const resetFitmentModal = ({ dispatch, commit }) => {
    commit('setFitsMode', false)

    if (didNotSave) {
        autoSelectEnabled = true
        dispatch('initSelects')
    }
}

const setupFitment = function ({ state, commit, getters, rootState }, route) {
    const newTypes = {
        required: ['year', 'make', 'model'],
        optional: [],
    }

    // Determine if this BBE are Required or Optional
    const bbeTypes = ['body', 'bed', 'engine']

    let extraData = {}

    if (route && route.matched.some((record) => record.meta.hasCustomFitment)) {
        extraData = rootState?.catalog?.data?.requiredFitmentOptions || {}
    }

    bbeTypes.forEach((type) => {
        const runtimeValue = this.$config.runtime.theme.fitment[type]
        const customValue = extraData[type]
        const currentFitmentValue = state.data[type]

        if (runtimeValue || customValue || currentFitmentValue) {
            // If its not required by default but is by apiData: set it to required
            if (currentFitmentValue || (runtimeValue !== 'required' && customValue)) {
                newTypes.required.push(type)
            } else newTypes[runtimeValue].push(type)
            // Otherwise obey the default (will set it to required if runtime and apiData agree or set it to optional)
        }
    })
    // Only commit if something changed
    if (state.requiredSelectTypes.length === newTypes.required.length) {
        // If the keys are exactly the same, early out
        if (
            state.requiredSelectTypes.every((selectType) => newTypes.required.includes(selectType))
        ) {
            commit('setHasRequiredFitmentChanged', false)
            return
        }
    }

    commit('setRequiredSelectTypes', newTypes.required)
    commit('setOptionalSelectTypes', newTypes.optional)
    commit('setHasRequiredFitmentChanged', true)
    // This is required to update the Order of the selects for mutation setSelectOptions
    commit('initSelects', getEmptySelects(state, getters.selectTypes))
}

const initSelects = function ({ dispatch }) {
    dispatch('fillNextSelect', { sourceType: null })

    // in the case where the screen rendered with an existing ymm, and they selected a ymm from a product line page, make sure to fill them up!
    autoSelectEnabled = true
}

const setSelectValue = ({ commit, getters }, { sourceType, newValue }) => {
    const index = getters.selectTypes.indexOf(sourceType)
    commit('setSelectValue', { index, newValue })
}

const fillNextSelect = async function ({ dispatch, state, commit, getters }, { sourceType }) {
    const destIndex = sourceType ? getters.selectTypes.indexOf(sourceType) + 1 : 0
    let doneSelectingRequired = false

    // if we don't have any optionalSelectTypes and we are selecting the last requiredSelectType then we need to disable the auto selecting feature.
    if (
        state.optionalSelectTypes.length === 0 &&
        sourceType === state.requiredSelectTypes.slice(-1)[0]
    )
        autoSelectEnabled = false
    // if we are done selecting the requiredSelectTypes then we need to know to be done with them so we trigger the correct things when we get algolia results.
    if (destIndex === state.requiredSelectTypes.length || state.modal.isStoppingInit)
        doneSelectingRequired = true
    this.$search.fitment.clearRefinements()

    state.requiredSelectTypes.forEach((select, index) => {
        // add the facet to the query if we have all of the required values or add filters for everything before destIndex
        if (doneSelectingRequired || index < destIndex) {
            const selectData = state.modal.selects[getters.selectTypes.indexOf(select)]
            if (selectData.currentValue !== -1)
                this.$search.fitment.addRefinements(
                    getTypeSlug(selectData.type),
                    selectData.currentValue
                )
        }
    })

    // Search for results
    await this.$search.fitment.search()

    // No Year Error Test: We need to alert segment if the years are missing
    if (
        !this.$search.fitment.state.refinements.year ||
        !Array.isArray(this.$search.fitment.state.refinements.year) ||
        this.$search.fitment.state.refinements.year.length <= 0
    ) {
        this.$uiEvents.$emit('errorLog', { errorType: 'no year in fitment' })
    }

    if (!doneSelectingRequired) {
        const destType = getters.selectTypes[destIndex]
        const options = [
            getEmptyOption(state, destType, true),
            ...getSelectOptions(destType, this.$search.fitment.state.refinements),
        ]
        commit('setSelectOptions', { index: destIndex, options })

        getters.selectTypes.forEach((select, index) => {
            if (index > destIndex) commit('setSelectDisabled', index)
        })

        const foundOption = findOptionByValue(options, state.data[getTypeSlug(destType)])
        // auto select their full or partial ymm, but only the first time through
        if (foundOption && autoSelectEnabled) {
            dispatch('setSelectValue', { sourceType: destType, newValue: foundOption.value }).then(
                () => {
                    dispatch('fillNextSelect', { sourceType: destType })
                }
            )
        }
    } else {
        state.optionalSelectTypes.forEach((select) => {
            const options = [
                getEmptyOption(state, select, true),
                ...getSelectOptions(select, this.$search.fitment.state.refinements),
            ]
            commit('setSelectOptions', { index: getters.selectTypes.indexOf(select), options })

            const foundOption = findOptionByValue(options, state.data[getTypeSlug(select)])
            // auto select their full or partial ymm, but only the first time through
            if (foundOption && autoSelectEnabled) {
                dispatch('setSelectValue', { sourceType: select, newValue: foundOption.value })
            }
        })

        // if we hit this point then we have already auto selected once, meaning that we don't want to auto populate anything anymore.
        autoSelectEnabled = false
    }
}

const validateFitment = async function ({ state, commit, getters }, { sourceType }) {
    this.$search.fitment.clearRefinements()

    // add filters for everything that we have values for.
    state.modal.selects.forEach((select) => {
        if (select.currentValue !== -1)
            this.$search.fitment.addRefinements(getTypeSlug(select.type), select.currentValue)
    })

    await this.$search.fitment.search()

    if (this.$search.fitment.state.resultCount === 0)
        commit('setSelectError', getters.selectTypes.indexOf(sourceType))
    else commit('resetSelectErrors')
}

// notice we start with a new obj, not try to merge selections
// if you pass it fitmentData, then it will save that instead
// this is used to overwrite the fitment data when editing a build
const saveFitment = ({ state, commit, getters }, fitmentData) => {
    const obj = {}

    getters.selectTypes.forEach((type, index) => {
        const selectedOption = findOptionByValue(
            state.modal.selects[index].options,
            state.modal.selects[index].currentValue
        )

        if (selectedOption.value !== -1) {
            obj[type] = selectedOption.text
            if (type !== 'year') obj[`${type}Slug`] = selectedOption.value
        }
    })

    commit('setFitmentData', { fitmentData: fitmentData || obj })
    didNotSave = false
}

const clearFitment = async function ({ dispatch, commit }) {
    commit('clearFitment')

    if (process.client) {
        await dispatch('setupFitment', this.$router.currentRoute)
        dispatch('initSelects')
    }
}

// gets params from the url and fetches their text versions to put your session together
// TODO: In prod see how slow this is, seems dumb to hit algolia for stuff that rarely changes
const setFitmentFromUrl = async function ({ commit, dispatch }, { params, res }) {
    commit('setIsStoppingInit', true)

    this.$search.fitment.clearRefinements()

    // if we have a model, filter by model because we'll automatically have a make
    if (params.modelSlug !== undefined)
        this.$search.fitment.addRefinements('modelSlug', params.modelSlug)
    if (params.makeSlug !== undefined)
        this.$search.fitment.addRefinements('makeSlug', params.makeSlug)
    if (params.year !== undefined) this.$search.fitment.addRefinements('year', params.year)

    await this.$search.fitment.search()

    if (this.$search.fitment.state.resultCount === 0) return false

    const [fitmentResult] = this.$search.fitment.state.results

    const obj = {
        make: fitmentResult.make,
        makeSlug: fitmentResult.makeSlug,
        ...(params.year && { year: `${fitmentResult.year}` }),
    }

    if (params.modelSlug) {
        if (params.modelSlug !== fitmentResult.modelSlug) return false

        obj.model = fitmentResult.model
        obj.modelSlug = fitmentResult.modelSlug
    }

    commit('setFitmentData', { res, fitmentData: obj, merge: false })
    commit('setIsStoppingInit', false)

    if (process.client) dispatch('initSelects')

    return true
}

export default {
    showFitmentModal,
    resetFitmentModal,
    setupFitment,
    initSelects,
    setSelectValue,
    saveFitment,
    clearFitment,
    fillNextSelect,
    validateFitment,
    setFitmentFromUrl,
}

function getTypeSlug(type) {
    return type === 'year' ? type : `${type}Slug`
}

// takes a select obj and returns the selected object
function findOptionByValue(options, value) {
    return options.filter((obj) => {
        return obj.value === value
    })[0]
}

function getSelectOptions(destType, facets) {
    const textFacets = facets[destType]
    const slugFacets = facets[`${destType}Slug`] || facets[destType]

    if (!textFacets) return []

    const options = textFacets.map((facet, index) =>
        getOptionObject(facet.value, slugFacets[index].value, false, false)
    )

    return destType !== 'year' ? options : options.reverse()
}

function getEmptySelects(state, selectTypes) {
    return selectTypes.map((type) => {
        return getEmptySelect(state, type)
    })
}

function getEmptySelect(state, type) {
    return {
        type,
        currentValue: -1,
        isDisabled: type !== 'year',
        options: [].concat(getEmptyOption(state, type)),
        hasError: false,
    }
}

// If you have a partial MMY then the first option will be "Chevy" instead of "Select Make" etc..  useRealDefault will always show Select ______
function getEmptyOption(state, type, useRealDefault = false) {
    const label =
        state.data && state.data[type] && !useRealDefault ? state.data[type] : `Select ${type}`

    return getOptionObject(label, -1, true, false)
}

function getOptionObject(text, value, isDisabled, isHidden) {
    return {
        text,
        value,
        isDisabled,
        isHidden,
    }
}
